import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionForm from '../../../components/forms/CompetitionForm';
import { useCompetitionApi } from '../../../hooks/useCompetitionApi';
import { useNavigate, useParams } from 'react-router-dom';
import { CompetitionDTO } from '../../../services/apiClient';

const CompetitionEdit: React.FC = () => {
  const { getById, edit } = useCompetitionApi();
  const [entityData, setEntityData] = useState<CompetitionDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competitions', href: '/admin/competitions' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Competition data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate(-1);
    } catch (error) {
      console.error('Error updating Competition:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitions"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Manage.Competition.Edit"
    >
      {entityData ? (
        <CompetitionForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default CompetitionEdit;
